import { ConnectedFacility, ConnectedFacilityOptimized } from '../../api';

export const getConnectionSenderName = (
  connectionRequest: ConnectedFacility | ConnectedFacilityOptimized
): string => {
  if (connectionRequest.healthcare_entity_rep) {
    const { first_name, last_name } = connectionRequest.healthcare_entity_rep;
    return `${first_name} ${last_name}`;
  }
  return 'Auto-Match';
};
